import React from "react";
import { useLocation, Route, Switch, Redirect } from "react-router-dom";

// import AdminNavbar from "../components/Navbars/AdminNavbar";
//import AdminFooter from "../components/Footers/AdminFooter";
import Sidebar from "components/Sidebar/Sidebar.js";
import routes from "../route/orgRoutes";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
React.useEffect(() => {
  document.documentElement.scrollTop = 0;
  document.scrollingElement.scrollTop = 0;
  if (mainContent.current) {
    mainContent.current.scrollTop = 0;
  }
}, [location]);
React.useEffect(() => {
  document.body.style.backgroundColor = "#fff";
  document.body.style.minHeight = "100vh";
  return () => {
    document.body.style.backgroundColor = "";
  };
}, []);

  return (
    <>
      <Sidebar
        {...props}
        routes={routes.filter((data)=>data.path != '/device/:id')}
        logo={{
          innerLink: "/device-list",
          imgSrc: require("../assets/img/brand/argon-react.png").default,
          imgAlt: "...",
        }}
      />
   <div className="main-content" ref={mainContent} style={{ background: "#fff", overflow: "auto", position: "relative", zIndex:1,  height: "100vh", display: "flex", flexDirection: "column",  paddingLeft: "16px"  }}>
  {/* <AdminNavbar
    {...props}
    routes={routes}
  /> */}
  <Switch>
    {routes.map((prop, key) => {
      if (prop.redirect) {
        return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
      } else {
        return <Route path={prop.path} component={prop.component} key={key} />;
      }
    })}
  </Switch>
</div>
    </>
  );
};

export default Admin;
